import keepAlive from 'lib/keep-alive';
import ContentPage from 'ef/models/content_page';
import Page from 'ef/models/page';
import EF from 'ef/ef';

const ProgressService = function () {
  this.saveProgress = function (model, page, cb) {
    let data;
    cb = cb || function () {};

    if (page instanceof ContentPage) {
      data = {
        key: page.key,
        page_key: page.key,
        completed: page.completed,
        data: page.pageData,
        activity_key: page.activityKey,
        module_key: page.moduleKey,
        date: new Date(),
      };
    } else if (page instanceof Page) {
      data = {
        key: page.get('key'),
        page_key: page.get('key'),
        completed: page.get('completed'),
        data: page.pageData,
        activity_key: page.activity.get('key'),
        module_key: page.activity.module.get('key'),
        date: new Date(),
      };
    }

    if (data) {
      data.content_id = EF.enrollment.get('contentId');
      model.savePage(page, data, cb);
    }

    keepAlive();
  };

  this.getPath = function (eid) {
    return `/progress/${eid}/page_progress`;
  };

  this.getRequestOptions = function (request) {
    const data = {
      data: {
        type: 'page_progress',
        attributes: request.data,
      },
    };

    return {
      type: 'POST',
      url: request.url,
      headers: {
        Authorization: `Bearer ${EF.config.get('accessToken')}`,
        'Content-Type': 'application/vnd.api+json',
      },
      processData: false,
      data: JSON.stringify(data),
    };
  };

  this.saveActivityProgress = function (model, grade, attempt, slug) {};

  this.saveCourseTimeProgress = function ({ intervalSeconds }) {
    if (
      !(EF.enrollment && EF.enrollment.get('id')) ||
      !(EF.config && EF.config.get('basePath')) ||
      !(EF.enrollment && EF.enrollment.get('contentId'))
    ) {
      return;
    }
    const progressId = EF.enrollment.get('id');
    const basePath = EF.config.get('basePath');
    const contentId = EF.enrollment.get('contentId');
    const url = `${basePath}/progress/${progressId}/time_log`;

    return this.sendRequestRemote(url,{
      data: {
        id: progressId,
        type: 'progress',
        attributes: {
          type: 'content',
          content_id: contentId,
          duration: `PT${intervalSeconds}S`,
        },
      },
    });
  };

  this.saveTwineVarsRemote = function (event_name, vars) {
    const { enrollment, config } = EF;
    const progressId = enrollment.get('id');
    const basePath = config.get('basePath');

    if (!progressId || !basePath) {
      return;
    }

    const url = `${basePath}/progress/${progressId}/progress_activities`;
    const { module_key, activity_key, page_key } = enrollment.get('data') || {};
    const attributes = {
      ...(module_key && { module_key }),
      ...(activity_key && { activity_key }),
      ...(page_key && { page_key }),
      event_name,
      properties: vars
    };

    return this.sendRequestRemote(url,{
      data: {
        type: 'progress_activities',
        attributes,
      },
    });
  };

  this.sendRequestRemote = function (url, requestBody) {
    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
        Authorization: `Bearer ${EF.config.get('accessToken')}`,
      },
      body: JSON.stringify(requestBody),
    });
  };
};

export default new ProgressService();
